module.exports = __webpack_public_path__ + "img/banner-3.b8428175.png";